import request from '@/src/utils/request'

//取得分店列表
export const getProductsInfo = async () => {
  const response = await request.post('/admin/product/search')
  return response
}
//取得寵物旅館設定
export const getHotelInfo = async () => {
  const response = await request.post('/admin/merchant/setting', {
    type: 'hotel',
  })
  return response.items
}
// 儲存寵物旅館設定
export const storeHotelInfo = async (payload) => {
  const response = await request.post('/admin/merchant/setting/store', {
    type: 'hotel',
    payload,
  })
  return response.data
}
//查詢現有房型及房況
export const postHotelRoomAvailability = async (payload) => {
  const response = await request.post('/admin/hotel/room/availability', payload)
  return response
}
//房況管理(單間/全部)
export const postHotelRoomScheduleStore = async (payload) => {
  const response = await request.post('/admin/hotel/room/schedule/store', payload)
  return response
}

export const getHotelRoom = async (productId) => {
  const response = await request.post('/admin/hotel/room/search', { productId: productId })
  return response
}

//是否開放房型預約
export const postHotelRoomTypeState = async (payload) => {
  const response = await request.post('/admin/hotel/room/type/state', payload)
  return response
}
//新增/編輯房型
export const postHotelRoomTypeStore = async (payload) => {
  const response = await request.post('/admin/hotel/room/type/store', payload)
  return response
}
// 取得房型詳細資料
export const getHotelRoomType = async (productId, roomTypeId) => {
  const response = await request.get(`/admin/hotel/${productId}/room/type/${roomTypeId}`)
  return response
}

// 取得"房型"不開放日期
export const getHotelRoomTypeClosedDates = async (productId, roomTypeId, payload) => {
  const response = await request.get(`/admin/hotel/${productId}/room/type/${roomTypeId}/closedDates`, { params: payload })
  return response
}

//取得"房間"不開放日期
export const getHotelRoomClosedDates = async (productId, roomId, payload) => {
  const response = await request.get(`/admin/hotel/${productId}/room/${roomId}/closedDates`, { params: payload })
  return response
}
export const getBoarding = async () => {
  const response = await request.post('/admin/product/boarding/forms/search')
  return response.items
}

export const storeBoarding = async (payload) => {
  const response = await request.post('/admin/product/boarding/forms/store', payload)
  return response.data
}

//取得寵物分類列表
export const getCategoryList = async () => {
  const response = await request.post('/admin/service/category/search')
  return response.items
}
/**
 * 搜尋價格規則
 * POST /api/admin/hotel/price/rule/search
 * @param {string} productId
 * @returns {Promise<Array>} items
 */
export const searchHotelPriceRules = async (productId) => {
  const res = await request.post('/admin/hotel/price/rule/search', { productId })
  return res.items
}

/**
 * 新增/編輯價格規則
 * POST /api/admin/hotel/price/rule/store
 * 注意：後端驗證通常是直接驗 body 欄位，不要包 payload:{...}
 * @param {object} payload
 */
export const storeHotelPriceRule = async (payload) => {
  return await request.post('/admin/hotel/price/rule/store', payload)
}

/**
 * 刪除價格規則（ids 陣列）
 * POST /api/admin/hotel/price/rule/remove
 * @param {number[]} ids
 */
export const removeHotelPriceRules = async (ids) => {
  return await request.post('/admin/hotel/price/rule/remove', { ids })
}

//新增/更新房型設備
export const postHotelRoomTypeFeature = async (productId, payload) => {
  const response = await request.post(`/admin/hotel/${productId}/room/type/feature`, payload)
  return response
}
// 取得房型設備列表
export const getHotelRoomTypeFeature = async (productId) => {
  const response = await request.get(`/admin/hotel/${productId}/room/type/feature`)
  return response
}
// 取得單筆房型設備
export const getHotelRoomTypeFeatureById = async (productId, featureId) => {
  const response = await request.get(`/admin/hotel/${productId}/room/type/feature/${featureId}`)
  return response
}
// 刪除房型設備
export const deleteHotelRoomTypeFeature = async (productId, featureId) => {
  const response = await request.delete(`/admin/hotel/${productId}/room/type/feature/${featureId}`)
  return response
}
